/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { goodLuckCoreDTOsTournamentWinnerPlayerDtoSchema } from "./tournamentWinnerPlayerDtoSchema.ts";
import { z } from "zod/v4";

export const goodLuckCoreDTOsTournamentWinnerDtoSchema = z.object({
  name: z.string().nullish(),
  type: z.string().nullish(),
  note: z.string().nullish(),
  get players() {
    return z.array(goodLuckCoreDTOsTournamentWinnerPlayerDtoSchema).nullish();
  },
  winnerId: z.string().nullish(),
});
